import { Box, Card, CardContent } from "@mui/material";
import TimelineHappy from "./TimelineHappy";

function App() {
  return (
    <Card elevation={1} sx={{ borderRadius: 5, p: 2 }}>
      <CardContent>
        <Box display={"flex"} justifyContent="space-between">
          <h4>Repeated measurements in daily life</h4>
        </Box>
        <Box padding={1} />
        <TimelineHappy />
      </CardContent>
    </Card>
  );
}

export default App;
